export const texts = {
  invalidTitle: {
    de: 'Der Link ist leider nicht mehr gültig!',
    en: 'Unfortunately this link is no longer valid!'
  },
  invalidLink: {
    de: 'Hier',
    en: 'Here'
  },
  invalidFooter: {
    de: 'kannst du dich anmelden oder ein neues Passwort anfordern',
    en: 'you can sign in or request a new password'
  },
  welcome: {
    de: 'Herzlich Willkommen!',
    en: 'Welcome!'
  },
  emailLabel: {
    de: 'E-Mail',
    en: 'Email'
  },
  salutationLabel: {
    de: 'Anrede',
    en: 'Salutation'
  },
  salutationFemale: {
    de: 'Frau',
    en: 'Ms.'
  },
  salutationMale: {
    de: 'Herr',
    en: 'Mr.'
  },
  salutationDiverse: {
    de: 'Divers',
    en: 'Diverse'
  },
  firstName: {
    de: 'Vorname',
    en: 'First name'
  },
  lastName: {
    de: 'Nachname',
    en: 'Last name'
  },
  passwordLabel: {
    de: 'Wähle dein Passwort',
    en: 'Choose your password'
  },
  submit: {
    de: 'Registrieren',
    en: 'Register'
  },
  hasAccount: {
    de: 'Du hast bereits einen Account?',
    en: 'Already have an account?'
  },
  toLogin: {
    de: 'Zum Login',
    en: 'To sign in'
  },
  errors: {
    missingSalutation: {
      de: 'Bitte geben Sie eine bevorzugte Anrede an',
      en: 'Please select a preferred salutation'
    },
    missingFirstName: {
      de: 'Bitte geben Sie Ihren Vornamen ein',
      en: 'Please enter your first name'
    },
    missingLastName: {
      de: 'Bitte geben Sie Ihren Nachnamen ein',
      en: 'Please enter your last name'
    },
    missingEmail: {
      de: 'Bitte geben Sie ein E-Mail-Adresse ein',
      en: 'Please enter an email address'
    },
    missingPassword: {
      de: 'Bitte geben Sie ein Passwort ein',
      en: 'Please enter a password'
    },
    generic: {
      de: 'Ein Fehler ist aufgetreten',
      en: 'An error occurred'
    }
  }
};
